import "./footer.scss"

const Footer = () => {
  return (
    <footer className="footer bg-primary-800
    ">
        <h6 className="ff-neutral fs-footer text-neutral-100">Designed & Built by Syed Taqi Abbas -2023</h6>
        <p className="email ff-neutral fs-footer link">taqiabbas8989@gmail.com</p>
    </footer>
  )
}

export default Footer